/**
 * Route: /splits (Index) — Story 2.3-UI (Split-Editor)
 *
 * Editor-Spalte ohne Auswahl: Hinweis-Karte mit CTA zur neuen Regel.
 * Die Regel-Liste rendert die Layout-Route (_auth.splits.tsx).
 */
import { createFileRoute } from '@tanstack/react-router'
import { SplitEditorPlaceholder } from '../features/splits/SplitsLayout'

export const Route = createFileRoute('/_auth/splits/')({
  component: SplitEditorPlaceholder,
})
